// extracted by mini-css-extract-plugin
module.exports = {"title":"XLYevQfCRaH7itSs2Iil3","description":"_1rNsADqykvpPpsM67ftaOU","footNotes":"_1FmHfAVfvL1a65ktXGzGW7","security":"zAPcQVrQE-3zatATnOzh5"};